import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, Tooltip } from '@mui/material';
import { Autocomplete, Button, TextField, Dialog } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import FlexBox from 'components/common/FlexBox';

const VerificationTypeModalComponent = ({
  title,
  onCloseModal,
  verificationTestResponse,
  onPropertyChange,
  onVerificationClickTest,
  documentTypes,
  documentNumber,
  documentTypeId,
  validation
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open
      fullWidth
      maxWidth='lg'
      onClose={onCloseModal}
      title={title}
      content={
        <FlexBox direction='column' gap={2}>
          <FlexBox alignItems='center' gap={2}>
            <FlexBox grow={1} gap={2}>
              <Autocomplete
                required
                fullWidth
                value={documentTypeId || ''}
                label={t('VerificationTypes.DocumentType')}
                options={documentTypes}
                onChange={value => onPropertyChange('documentTypeId', value)}
                simpleValue
                error={!isValid(validation.documentTypeId)}
                helperText={getErrors(validation.documentTypeId)}
              />
              <Tooltip title={t('VerificationTypes.TestingApplicabilityFormula.DocumentId')}>
                <TextField
                  required
                  fullWidth
                  value={documentNumber || ''}
                  onChange={value => onPropertyChange('documentNumber', value)}
                  label={t('VerificationTypes.TestingApplicabilityFormula.Identifier')}
                  error={!isValid(validation.documentNumber)}
                  helperText={getErrors(validation.documentNumber)}
                />
              </Tooltip>
            </FlexBox>
            <FlexBox>
              <Button
                disabled={!documentNumber || !documentTypeId}
                tooltip={
                  documentNumber && documentTypeId
                    ? t('Tooltips.Test')
                    : t('VerificationTypes.TestingApplicabilityFormula.Validations.InvalidEntityIdentifier')
                }
                onClick={() => documentNumber && documentTypeId && onVerificationClickTest()}
              >
                {t('Tooltips.Test')}
              </Button>
            </FlexBox>
          </FlexBox>
          {verificationTestResponse.length > 0 && (
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Typography>{t('VerificationTypes.TestingApplicabilityFormula.PartnerName')}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography>{t('VerificationTypes.TestingApplicabilityFormula.PartnerRoleName')}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography>{t('VerificationTypes.VerificationName')}</Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography>{t('VerificationTypes.TestingApplicabilityFormula.Result')}</Typography>
              </Grid>
              {verificationTestResponse &&
                verificationTestResponse.map((item, idx) => (
                  <Grid container item xs={12} key={idx} spacing={1}>
                    <Grid item xs={4}>
                      <Tooltip title={item.partnerName}>
                        <TextField fullWidth value={item.partnerName} name={'partnerName'} disabled />
                      </Tooltip>
                    </Grid>
                    <Grid item xs={3}>
                      <TextField fullWidth value={item.partnerRoleName} name={'partnerRoleName'} disabled />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField fullWidth value={item.verificationName} name={'verificationName'} disabled />
                    </Grid>
                    <Grid item xs={1}>
                      <TextField fullWidth value={item.result} name={'result'} disabled />
                    </Grid>
                  </Grid>
                ))}
            </Grid>
          )}
        </FlexBox>
      }
    ></Dialog>
  );
};

VerificationTypeModalComponent.propTypes = {
  title: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  verificationTestResponse: PropTypes.array.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  onVerificationClickTest: PropTypes.func.isRequired,
  documentTypes: PropTypes.array.isRequired,
  documentNumber: PropTypes.string.isRequired,
  documentTypeId: PropTypes.array.isRequired,
  validation: PropTypes.object
};

export default VerificationTypeModalComponent;
